export enum RenterPolicyType {
    DELETED_RENTED = "DELETED_RENTED",
    NOTIFICATION_DEFAULT = "NOTIFICATION_DEFAULT",
    RENTER_POLICY = "RENTER_POLICY"
}